module.exports = __webpack_public_path__ + "img/sesame_seeds.952da20b.svg";